import Analytics from '@/mixins/Analytics';
import eventNames from '@/constants/analyticsEventNames';

const browserNotification = (title, vehicleName, thumbnail, auctionId, store, data, type) => {
  if ('Notification' in window) {
    const options = {
      body: vehicleName,
      icon: thumbnail,
    };

    const showNotification = () => {
      const notification = new Notification(title, options);
      notification.onclick = () => {
        if (import.meta.env.VITE_ENV_NAME !== 'development' || store.state.devTools.analyticsLoggingEnabled) {
          Analytics.methods.track(eventNames.notifications.pushNotificationClicked, {
            auction_id: auctionId,
            acv_message_type: type,
          });
        }
        // eslint-disable-next-line no-underscore-dangle
        store._vm.$root.$emit('acv::browser-notification-click', data);
      };
    };

    // user has previously allowed our domain
    if (Notification.permission === 'granted') {
      showNotification();
    } else if (Notification.permission !== 'denied') {
      // show the popup, ask nicely
      Notification.requestPermission().then((permission) => {
        if (permission === 'granted') {
          showNotification();
        }
      });
    }
  } else {
    // TODO: anything to do in this case?
    // alert("This browser does not support desktop notification");
  }
};

const sendAuctionNotification = (auction, msg, store, type) => {
  if (auction && msg) {
    browserNotification(
      auction.vehicleDisplayName,
      msg,
      auction.photoThumbnail,
      auction.id,
      store,
      auction,
      type,
    );
  }
};

export { browserNotification, sendAuctionNotification };
